import { connect } from 'react-redux';
import HeroBanner from './hero_banner';

const mapStateProps = ({ homePage }) => ({
  loading: homePage?.loading
});

export default connect(
  mapStateProps
)(HeroBanner);
